/*
 * Copyright (c) 2025 to Present Applause App Quality, Inc. All rights reserved
 */

import Embed from 'quill/blots/embed';


export class PlatformImageEmbed extends Embed {
  static blotName = 'pendingImage';
  static tagName = 'img';

  static extractAttributesFromNode(node: HTMLImageElement): any {
    return {
      src: node.getAttribute('src'),
      pendingId: node.getAttribute('data-pending-id'),
      attachmentId: node.getAttribute('data-attachment-id'),
      pendingAttachmentClone: node.getAttribute('data-pending-attachment-clone'),
      width: node.getAttribute('width'),
      height: node.getAttribute('height')
    };
  }

  private static isValidAttributeValue(value: any): boolean {
    return value && value !== 'null';
  }

  static create(value: any) {
    const node = super.create() as HTMLImageElement;
    node.setAttribute('src', value.src);

    // Handle pending images (new), saved images (existing), and pending clones (deferred)
    if (PlatformImageEmbed.isValidAttributeValue(value.pendingId)) {
      node.setAttribute('data-pending-id', value.pendingId);
    }
    if (PlatformImageEmbed.isValidAttributeValue(value.attachmentId)) {
      node.setAttribute('data-attachment-id', value.attachmentId);
    }
    if (PlatformImageEmbed.isValidAttributeValue(value.pendingAttachmentClone)) {
      node.setAttribute('data-pending-attachment-clone', value.pendingAttachmentClone);
    }

    // Preserve image dimensions
    if (PlatformImageEmbed.isValidAttributeValue(value.width)) {
      node.setAttribute('width', value.width);
    }
    if (PlatformImageEmbed.isValidAttributeValue(value.height)) {
      node.setAttribute('height', value.height);
    }

    return node;
  }

  static value(node: any) {
    return PlatformImageEmbed.extractAttributesFromNode(node);
  }
}